@use "Styles/mixins";
@use "Styles/includes/variables";

:host {
    --vm-video-info-bg: #{mixins.get-color(bg, solid, primary)};
    display: block;
    font-family: variables.$fontQuaternary;
    box-sizing: border-box;
    line-height: 1;
}

.vm-video-info {
    &__avatars {
        display: none;
        @include mixins.desktop-and-up {
            display: block;
            position: relative;
            flex-shrink: 0;

            &:has(.vm-video-info__contributor-avatar) {
                margin-right: 12px;
            }
        }
    }

    &__wrap {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 0px;
        @include mixins.desktop-and-up {
            gap: 8px;
        }
    }

    &__subtitle-wrap {
        display: flex;
        gap: 12px;
        flex-direction: column;

        @include mixins.desktop-and-up {
            flex-direction: row;
            align-items: center;
            gap: 16px;
        }
    }

    &__actions-slot {
        display: block;
        flex: 0 0 auto;
    }

    &__avatar {
        display: none;
        @include mixins.desktop-and-up {
            display: block;
            flex-shrink: 0;
            border-radius: 50%;
            overflow: hidden;
        }
    }

    &__byline-logo {
        position: relative;
        border-radius: 50%;
        background: mixins.get-color(bg, solid, primary);

        &::after {
            content: "";
            position: absolute;
            inset: 0;
            border-radius: 50%;
            border: 1px solid mixins.get-color(border, solid, disabled);
        }

        &::part(image) {
            object-position: unset;
        }
    }

    &__contributor-avatar {
        position: absolute;
        top: 31px;
        left: 34px;
        border-radius: 50%;
        box-shadow: 0 0 0 2px mixins.get-color(bg, solid, primary);
    }

    &__text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-width: 0;
        flex: 1 1 auto;
        gap: 4px;
    }

    &__title {
        margin: 0;
        font-weight: 900;
        color: mixins.get-color(text, text-primary);
        font-size: mixins.get-font-size(text-lg);
        line-height: mixins.get-line-height(text-lg);
        @include mixins.desktop-and-up {
            line-height: mixins.get-line-height(text-xl);
            font-size: mixins.get-font-size(text-xl);
        }
    }

    &__subtitle {
        margin: 0;
        display: none;
        font-size: mixins.get-font-size(text-lg);
        font-weight: 400;
        line-height: mixins.get-line-height(text-lg);
        color: mixins.get-color(text, text-primary);
        @include mixins.desktop-and-up {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
            font-weight: 700;
        }
    }

    &__byline-link,
    &__contributor-link {
        color: inherit;
        text-decoration: none;
        font-weight: 700;

        &:hover {
            text-decoration: underline;
        }
    }

    &__meta {
        margin: 0;
        font-size: mixins.get-font-size(text-sm);
        line-height: mixins.get-line-height(text-sm);
        color: mixins.get-color(text, text-placeholder);
        @include mixins.desktop-and-up {
            color: mixins.get-color(text, text-tertiary);
        }
    }

    &__meta-item {
        &--hide-mobile {
            display: none;
            @include mixins.desktop-and-up {
                display: unset;
            }
        }
    }

    &__contributor-name {
        font-weight: 700;
    }

    &__mobile-subtitle {
        display: block;
        position: relative;
        overflow: hidden;
        max-height: calc(#{mixins.get-line-height(text-sm)} * 2);
        margin: 0;
        padding: 0;
        border: none;
        background: transparent;
        font: inherit;
        font-weight: 400;
        font-size: mixins.get-font-size(text-sm);
        line-height: mixins.get-line-height(text-sm);
        color: mixins.get-color(text, text-secondary);
        text-align: left;
        cursor: pointer;
        width: 100%;

        @include mixins.desktop-and-up {
            display: none;
        }
    }

    &__mobile-subtitle-text {
        display: inline;
    }

    &__more-info {
        display: inline;
        font-weight: 700;
        color: inherit;
        margin-left: 2px;
    }

    &__mobile-subtitle--truncated {
        .vm-video-info__more-info {
            position: absolute;
            bottom: 0;
            right: 0;
            margin-left: 0;
            background: var(--vm-video-info-bg);
            // padding-left: 1em;

            &::before {
                content: "";
                position: absolute;
                right: 100%;
                top: 0;
                bottom: 0;
                width: 1em;
                background: linear-gradient(to right, transparent, var(--vm-video-info-bg));
                pointer-events: none;
            }
        }
    }
}
